import { FlowStateController } from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";

import {
    BackgroundEvents,
    EventsManager,
    FlowEvents,
    GameEvents,
    ReelsEvents,
} from "../../../abstracts/events/EventsManager";
import { AbstractFlowPresentation } from "../../../abstracts/flow/AbstractFlowStatePresentation";
import { AbstractGameMode } from "../../../abstracts/flow/AbstractGameMode";
import { shuffleArray } from "../../../abstracts/utils/ArrayUtils";
import { playSound } from "../../../abstracts/utils/SoundUtils";
import { DDDSoundNames, reelLandingSounds } from "../../assetsLoader/DDDAssetsNames";
import { normalConfig } from "../../config/DDDConfig";
import { DDDBackgroundView } from "../../modules/Background/DDDBackgroundView";
import DDDReel from "../../modules/Reels/DDDReel";
import { DDDReelsView } from "../../modules/Reels/DDDReelsView";

export class DDDNormalBetPresentation extends AbstractFlowPresentation {
    protected reelsView: DDDReelsView;
    protected backgroundView: DDDBackgroundView;
    protected gameReels: DDDReel[] = [];

    constructor(protected id: string = `DDDNormalBetPresentation`) {
        super(id);
    }

    protected handleEvents(): void {
        super.handleEvents();

        EventsManager.on(ReelsEvents.GET_REELS, (ucReels: DDDReel[]) => {
            this.gameReels = ucReels;
        });

        EventsManager.on(ReelsEvents.GET_REELS_VIEW, (reelsView: DDDReelsView) => {
            this.reelsView = reelsView;
        });

        EventsManager.on(
            BackgroundEvents.GET_BACKGROUND_VIEW,
            (backgroundView: DDDBackgroundView) => {
                this.backgroundView = backgroundView;
            }
        );
    }

    public start(flowStateController: FlowStateController) {
        super.start(flowStateController);

        shuffleArray(reelLandingSounds);

        this.gameReels.forEach((reel, reelIndex) => {
            this.flowPresentationTimeline.call(() => reel.resetOnStartSpin(), undefined, 0);
            this.flowPresentationTimeline.add(
                reel.startNormalBetAnimation(),
                normalConfig.startMinDelay! + normalConfig.startReelsDelay! * reelIndex
            );
        });

        this.flowPresentationTimeline.resume();

        EventsManager.trigger(GameEvents.DISABLE_IDLE_ANIMATIONS);

        playSound({ name: DDDSoundNames.REELS_SPIN, repeat: 10 });
    }

    protected onBetStarted(): void {
        EventsManager.trigger(FlowEvents.BET_STARTED);

        if (this.model.data.nextMode === AbstractGameMode.NORMAL) {
            EventsManager.trigger(ReelsEvents.REMOVE_FAKE_SCATTERS);
        }
    }
}
